<template>
  <div class="tablelist">
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
       no-data-label="No se encuentran datos para esta busqueda"
    >
    <div>
    </div>
      <template slot="Banner" slot-scope="props">
        <div v-if="props.rowData.isStatusUpdateSuccessfull === true" class="msnexito">
          Actualizado
        </div>
        <div v-else-if="props.rowData.isStatusUpdateSuccessfull === false" class="msnfallido">
          Fallido
        </div>
        <div v-else>
          No procesado
        </div>
      </template>
      <template slot="actions" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <div v-if="item.action === 'status_user'">
              <img v-if="props.rowData.staNextPeriod === true" class="imgdata ma-0" :id="'img_' + props.rowIndex" src="../../assets/images/user_check.png" width="20"  @click="dataUser(props, item.action)"/>
              <img v-else class="imgdata ma-0" :id="'img_' + props.rowIndex" src="../../assets/images/user_inactive.png" width="20"  @click="dataUser(props, item.action)"/>
          </div>
        </div>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  data () {
    return {
      term: null,
      student: null,
      perPage: '20',
      perPageOptions: ['4', '6', '10', '20'],
      users: this.InfoView,
      StatusOptions: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
      StatusOptionsModel: '',
      ProgramsOptionsModel: '',
      StudentsOptionsModel: '',
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (((!this.term) || (this.term.length < 1)) && (!this.StudentsOptionsModel) && (!this.ProgramsOptionsModel) && (!this.StatusOptionsModel.id)) {
        return this.users
      }

      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.idBanner.toLowerCase().startsWith(this.term.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        if (this.StudentsOptionsModel) {
          return item.typeStudent.toLowerCase().startsWith(this.StudentsOptionsModel.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        if (this.ProgramsOptionsModel) {
          return item.namProgram.toLowerCase().startsWith(this.ProgramsOptionsModel.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        switch (this.StatusOptionsModel.id) {
          case 1:
            return item.staNextPeriod === true
          case 2:
            return item.staNextPeriod === false
          default:
            return item
        }
      })
    },
  },
  methods: {
    dataUser (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

/*va-button va-button--outline va-button--normal*/
.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
}
</style>
